import { useEffect, useState, useRef } from "react";
import { LoadPanel, TextBox } from "devextreme-react";
import axios from "axios";
import { ColumnDropdown } from "../../components/Dropdownn";
import { handleGetLocal } from "../../services/auth-service";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../components/Logout";
import "./AddEditConditionVerbiage.css";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae }) => (
  <ColumnDropdown
    data={dropDownData}
    setfields={setfields}
    fields={fields}
    fieldNmae={fieldNmae}
    value={fields[fieldNmae]?.name}
  />
);

const AddEditOffense = ({ mode, rowData, setPopupOpen, refresh,toastConfig, setToastConfig }) => {
  const navigate = useNavigate();
  const pathname = handleGetLocal("pathURL");
  const componentRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [offenseTypeDropdown, setOffenseTypeDropdown] = useState([]);
  const [convictionTypeDropdown, setConvictionTypeDropdown] = useState([]);

  const [fields, setFields] = useState({
    OffenseName: "",
    OffenseType: { name: "", id: "" },
    ConvictionType: { name: "", id: "" },
  });
  console.log("rowData in popup", rowData);
  const [validation, setValidation] = useState({});
  console.log("fields", fields);
  const getDropdowns = () => {
    setLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/docket/docket-dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: pathname,
        },
      })
      .then((res) => {
        const data = res?.data?.data || {};

        const offenseTypes =
          data.offenseType?.map((o) => ({
            name: o.value,
            id: o.key,
          })) || [];

        const convictionTypes =
          data.convictionType?.map((c) => ({
            name: c.value,
            id: c.key,
          })) || [];

        setOffenseTypeDropdown(offenseTypes);
        setConvictionTypeDropdown(convictionTypes);
        setLoading(false);
      })
      .catch(handleError);
  };
 useEffect(() => {
  if (mode === "EDIT" && rowData) {
    setFields({
      OffenseName: rowData?.sName || "",
      OffenseType: {
        name: rowData?.sOffenseType,
        id: rowData?.gOffenseTypeId,
      },
      ConvictionType: {
        name: rowData?.sConvictionType,
        id: rowData?.gConvictionTypeId,
      },
    });
  }

  if (mode === "ADD") {
    setFields({
      OffenseName: "",
      OffenseType: { name: "", id: "" },
      ConvictionType: { name: "", id: "" },
    });
    setValidation({});
  }
}, [mode, rowData]);


  useEffect(() => {
    getDropdowns();
  }, []);

  /* ---------------- Validation ---------------- */
  const validateFields = () => {
    const errors = {};
    if (!fields.OffenseName) errors.OffenseName = "Required";
    if (!fields.OffenseType.id) errors.OffenseType = "Required";
    if (!fields.ConvictionType.id) errors.ConvictionType = "Required";

    setValidation(errors);
    return Object.keys(errors).length === 0;
  };

  /* ---------------- Save ---------------- */
  const saveOffense = () => {
    if (!validateFields()) return;

    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/docket/save-offense`,
        {
          gOffenseId: mode === "EDIT" ? rowData?.gOffenseId : null,
          sName: fields.OffenseName,
          gOffenseTypeId: fields.OffenseType.id,
          gConvictionTypeId: fields.ConvictionType.id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: pathname,
          },
        }
      )
      .then((res) => {
        setPopupOpen(false);
        setToastConfig((prev) => ({
          ...prev,
          isVisible: true,
          type: "success",
          message:
            mode === "EDIT" ? "Offenses updated successfully" : "Offenses  Verbiage added successfully",
        }));
        setTimeout(() => {
          setToastConfig({
            ...toastConfig,
            isVisible: false,
            message:
              mode === "EDIT" ? "Offenses  updated successfully" : "Offenses  added successfully",
            type: "success",
          });
        }, 1900);
        refresh();
        setLoading(false);
      })
      .catch(handleError);
  };

  const handleError = (err) => {
    setLoading(false);
    if (!err?.response) navigate("/error/500");
    else if (err?.response?.status === 401) logOut();
  };

  return (
    <>
      <LoadPanel visible={loading} delay={10} />
      <div ref={componentRef} className="notes_edit_popup condition_verbiage_popup">
        {/* HEADER (same as Condition Verbiage) */}
        <div className="RecivePaymentModel_header">
          <div style={{ width: "107px" }} className="RecivePaymentModel_header_name">
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.41 5.41L14.58 0.58C14.21 0.21 13.7 0 13.17 0H2C0.9 0 0 0.9 0 2V14.01C0 15.11 0.89 16 1.99 16H18C19.1 16 20 15.1 20 14V6.83C20 6.3 19.79 5.79 19.41 5.41ZM13 1.5L18.5 7H14C13.45 7 13 6.55 13 6V1.5Z"
                fill="white"
              />
            </svg>
            <p style={{ marginLeft: "-10px" }}>{mode === "EDIT" ? "Edit Offense" : "Add Offense"}</p>
            {/* <span
              style={{
                padding: "2px 9px",
                gap: "8px",
                width: "45px",
                height: "24px",
                background: "#FEF2F2",
                borderRadius: "4px",
              }}
            >
              <p
                style={{
                  color: "#DC2626",
                  fontFamily: "Readex Pro",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "10px",
                  lineHeight: "20px",
                  width: "21px",
                  height: "20px",
                }}
              >
                MB.3
              </p>
            </span> */}
          </div>

          <svg
            onClick={() => setPopupOpen(false)}
            style={{
              cursor: "pointer",
              marginTop: "17px",
              marginRight: "2%",
            }}
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
              fill="white"
            />
          </svg>
        </div>

        {/* BODY */}
        <div className="editTable_notes">
          <div className="editTable_notes_bottom">
            <div style={{ width: "55%" }}>
              <p className="go-to-label-filed">
                Offense Name <em style={{ color: "red" }}>*</em>
              </p>
              <TextBox value={fields.OffenseName} onValueChange={(e) => setFields({ ...fields, OffenseName: e })} />
              {validation.OffenseName && <p className="error">{validation.OffenseName}</p>}
            </div>
          </div>
          <div className="editTable_notes_bottom">
            <div style={{ width: "55%" }}>
              <p className="go-to-label-filed">
                Offense Type <em style={{ color: "red" }}>*</em>
              </p>
              <DropDown
                dropDownData={offenseTypeDropdown}
                fieldNmae="OffenseType"
                fields={fields}
                setfields={setFields}
              />
            </div>
          </div>
          <div className="editTable_notes_bottom">
            <div style={{ width: "55%" }}>
              <p className="go-to-label-filed">
                Conviction Type <em style={{ color: "red" }}>*</em>
              </p>
              <DropDown
                dropDownData={convictionTypeDropdown}
                fieldNmae="ConvictionType"
                fields={fields}
                setfields={setFields}
              />
            </div>
          </div>

          {/* FOOTER */}
          <div className="popup_buttons">
            <button className="btn primary_btn" onClick={() => setPopupOpen(false)}>
              Cancel
            </button>
            <button className="btn primary_btn" onClick={saveOffense}>
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddEditOffense;
